import { render, staticRenderFns } from "./CreditsList.vue?vue&type=template&id=138e5bf5&"
import script from "./CreditsList.vue?vue&type=script&lang=js&"
export * from "./CreditsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports